import type { Router } from '@/domain/shared/types';
import type { checkoutAPIClient } from '../../infrastructure/api';
import type { groupBookingsAPIClient } from '@/infrastructure/groups/api';
import createDependenciesScope from '@/scopes/common/infrastructure/dependencies/createDependenciesScope';

interface GroupsDependencies {
  checkoutAPIClient: typeof checkoutAPIClient;
  groupBookingsAPIClient: typeof groupBookingsAPIClient;
  router: Router;
}

const { Provider, useDependency } = createDependenciesScope<GroupsDependencies>();

export const GroupsDependenciesProvider = Provider;
export const useGroupsDependency = useDependency;
